import React from 'react'
import ListControl from './../ListControl'
import RadioIcon from './RadioIconSvg'

export default props => <ListControl
  {...props}
  icon={<RadioIcon />}
/>


// WEBPACK FOOTER //
// ./src/modules/RadioControl/RadioControl.js